/*
 * L.TileLayer.Grayscale is a regular tilelayer with grayscale makeover.
 */

L.TileLayer.Grayscale = L.TileLayer.extend({
  options: {
    quotaRed: 21,
    quotaGreen: 71,
    quotaBlue: 8,
    quotaDividerTune: 0,
    quotaDivider: function () {
      return this.quotaRed + this.quotaGreen + this.quotaBlue + this.quotaDividerTune;
    }
  },

  initialize: function (url, options) {
    options = options || {}
    options.crossOrigin = true;
    L.TileLayer.prototype.initialize.call(this, url, options);

    this.on('tileload', function (e) {
      this._makeGrayscale(e.tile);
    });
  },

  _createTile: function () {
    var tile = L.TileLayer.prototype._createTile.call(this);
    tile.crossOrigin = "Anonymous";
    return tile;
  },

  _makeGrayscale: function (img) {
    if (img.getAttribute('data-grayscaled'))
      return;

    img.crossOrigin = '';
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var pix = imgd.data;
    for (var i = 0, n = pix.length; i < n; i += 4) {
      pix[i] = pix[i + 1] = pix[i + 2] = (this.options.quotaRed * pix[i] + this.options.quotaGreen * pix[i + 1] + this.options.quotaBlue * pix[i + 2]) / this.options.quotaDivider();
    }
    ctx.putImageData(imgd, 0, 0);
    img.setAttribute('data-grayscaled', true);
    img.src = canvas.toDataURL();
  }
});

L.tileLayer.grayscale = function (url, options) {
  return new L.TileLayer.Grayscale(url, options);
};

(function ($) {



  function resizeMarkers(markers, zoomLevel) {
    const newSize = getIconSize(zoomLevel); // Calculate new size based on zoom level
    const newAnchor = [newSize[0], newSize[1]]; // Calculate new anchor

    markers.forEach((marker) => {
      const icon = marker.getIcon();
      icon.options.iconSize = newSize;
      icon.options.iconAnchor = newAnchor;
      marker.setIcon(icon);
    });
  }

  function getIconSize(zoomLevel) {
    // Adjust these values as per your requirement
    if (zoomLevel > 15) return [80, 80]; // Original size for closer zoom
    if (zoomLevel > 10) return [80, 80]; // Medium size
    return [40, 40]; // Smaller size for further zoom
  }


  /**
   * initMap
   *
   * Renders a Leaflet Map onto the selected jQuery element
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create generic map.
    var map = L.map($el[0],
      {
        maxZoom: 19,
        fadeAnimation: false,
        attributionControl: false,
        zoomControl: true,
        scrollWheelZoom: false,
        dragging: !L.Browser.mobile,
        tap: !L.Browser.mobile
      }
    ); // Default center on Budapest
    L.tileLayer.grayscale('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);


    map.on("zoomend", () => {

      resizeMarkers(map.markers, map.getZoom());


    });

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @param   jQuery $marker The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var iconUrl = $marker.data('icon');
    var latLng = [parseFloat(lat), parseFloat(lng)];

    // Check if iconUrl exists, otherwise use default icon
    var markerOptions = {};
    if (iconUrl) {
      var customIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [80, 80], // Set to 80x80
        iconAnchor: [40, 80], // Adjust anchor for proper positioning
        popupAnchor: [0, -80] // Position popup relative to the icon
      });
      markerOptions.icon = customIcon;
    }

    // Create marker instance.
    var marker = L.marker(latLng, markerOptions).addTo(map);

    // Open URL when marker is clicked
    var url = $marker.data('url');
    if (url) {
      marker.on('click', function () {
        window.open(url, '_blank');
      });
    }

    // Append to reference for later use.
    map.markers.push(marker);
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {

    // Create map boundaries from all map markers.
    var bounds = new L.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend(marker.getLatLng());
    });

    // Fit the map to the marker bounds
    if (map.markers.length > 0) {
      map.fitBounds(bounds);
      resizeMarkers(map.markers, map.getZoom());
    }
  }

  // Render maps on page load.
  $(document).ready(function () {
    $('.js-map').each(function () {
      var map = initMap($(this));
    });
  });

})(jQuery);
